var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    _vm._g(
      {
        ref: "_in",
        staticClass: "_btn",
        class: ((_obj = {}),
        (_obj[_vm.tone] = _vm.tone),
        (_obj.outline = !_vm.ivalue),
        _obj),
        attrs: {
          type: "button",
          id: _vm.id,
          disabled: _vm.disabled,
          inert: _vm.inert,
          tabindex: _vm.inert ? -1 : _vm.tabindex
        }
      },
      _vm.__on
    ),
    [_vm._t("default", [_vm._v("﻿")])],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }